<template>
<div class="chapter">
<div class="inner_page">
<a id="VPS-5">
<h1 class="top">Table of Contents</h1>
</a><h2 class="toc"><a id="VPS-5"></a><a href="#/xhtml/006_Acknowledgmentes">Acknowledgments </a></h2>
<h2 class="toc"><a href="#/xhtml/007_List_of_Abbrivation"> List of Abbreviations Used in Notes </a></h2>
<h2 class="toc"><a href="#/xhtml/007_List_of_Abbrivation#a1">Glossary of  Terms </a></h2>
<h2 class="toc"><a href="#/xhtml/008_FM1"> Organizations </a></h2>
<h2 class="toc"><a href="#/xhtml/009_Introduction"> Introduction </a></h2>
<h2 class="toc"><a href="#/xhtml/010_Chapter_1">Chapter One: Building Defenses on the Lower Mississippi River</a></h2>
<h2 class="toc"><span href="#/xhtml/011_Chapter_2" title="Link target outside of Sample">Chapter Two: Initial Movements and Counters</span></h2>
<h2 class="toc"><span href="#/xhtml/012_Chapter_3" title="Link target outside of Sample">Chapter Three: Strengthening the Confederate Navy on the Mississippi River</span></h2>
<h2 class="toc"><span href="#/xhtml/013_Chapter_4" title="Link target outside of Sample">Chapter Four: The Campaign for the Upper Mississippi River</span></h2>
<h2 class="toc"><span href="#/xhtml/014_Chapter_5" title="Link target outside of Sample"> Chapter Five: Operations in Coastal Louisiana and Mississippi</span></h2>
<h2 class="toc"><span href="#/xhtml/015_Chapter_6" title="Link target outside of Sample">Chapter Six: The Campaign for New Orleans</span></h2>
<h2 class="toc"><span href="#/xhtml/016_Chapter_7" title="Link target outside of Sample">Chapter Seven: The First Campaign for Vicksburg</span></h2>
<h2 class="toc"><span href="#/xhtml/017_Chapter_8" title="Link target outside of Sample">Chapter Eight: Shift to the Unconventional</span></h2>
<h2 class="toc"><span href="#/xhtml/018_Chapter_9" title="Link target outside of Sample">Chapter Nine: River Operations in Southern Louisiana</span></h2>
<h2 class="toc"><span href="#/xhtml/019_Chapter_10" title="Link target outside of Sample">Chapter Ten: The Loss of Vicksburg and the Yazoo River</span></h2>
<h2 class="toc"><span href="#/xhtml/020_Chapter_11" title="Link target outside of Sample">Chapter Eleven: Defending the Red River</span></h2>
<h2 class="toc"><span href="#/xhtml/021_Chapter_12" title="Link target outside of Sample">Chapter Twelve: Denouement on the Tributaries</span></h2>
<h2 class="toc"><span href="#/xhtml/022_Chapter_13" title="Link target outside of Sample">Chapter Thirteen: Confederate Riverine Ambitions, Innovations, and Effectiveness </span></h2>
<h2 class="toc"><span href="#/xhtml/023_Epigraph" title="Link target outside of Sample">Epilogue: Analysis and Conclusions</span></h2>
<h2 class="toc"><span href="#/xhtml/024_Biblography" title="Link target outside of Sample">Bibliography</span></h2>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// toc.vue?7c1232b3